// import { Line } from "react-chartjs-2";
// import {
//     Chart as ChartJS,
//     LineElement,
//     PointElement,
//     CategoryScale,
//     LinearScale,
//     TimeScale,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import 'chartjs-adapter-date-fns';
  
// ChartJS.register(
//     LineElement,
//     PointElement,
//     CategoryScale,
//     LinearScale,
//     TimeScale,
//     Tooltip,
//     Legend
// );

// const Construct_code_category = [
//     { construct: "Self-Efficacy", code: "se", category: "Student Beliefs" },
//     { construct: "Cognitive Engagement", code: "cog", category: "Learning Behaviors" },
//     { construct: "Behavioral Engagement", code: "beh", category: "Learning Behaviors" },
//     { construct: "Affective Engagement", code: "aff", category: "Learning Behaviors" },
//     { construct: "Autonomy", code: "aut", category: "Classroom Context" },
//     { construct: "Relatedness", code: "rel", category: "Classroom Context" },
//     { construct: "Value", code: "val", category: "Student Beliefs" },
//     { construct: "Self-Regulation", code: "srt", category: "Learning Behaviors" },
//     { construct: "Intrinsic Motivation", code: "amot", category: "Student Beliefs" }, // or autonomous motivation? 
//     { construct: "Extrinsic Motivation", code: "cmot", category: "Student Beliefs" }, // or controlled motivation?
//     { construct: "Academic Burden", code: "bur", category: "Student Beliefs" },
//     { construct: "Belongingness", code: "bel", category: "Classroom Context" }, // or perceived belonging?
//     { construct: "Cultural Congruity", code: "cult", category: "Classroom Context" },
//     { construct: "Withdrawal Intention", code: "with", category: "Learning Behaviors" },
// ];

// const TrendChart = ({ trendData }) => {
//     console.log("TrendChart - trendData:", trendData);
//     const ConstructMeta = {};
//     Construct_code_category.forEach(({ code, construct, category }) => {
//       ConstructMeta[code] = { construct, category };
//     });
  
//     const trendByCategory = {
//       "Student Beliefs": {},
//       "Learning Behaviors": {},
//       "Classroom Context": {},
//     };
  
//     for (const [code, points] of Object.entries(trendData)) {
//       const meta = ConstructMeta[code] || {};
//       const category = meta.category || "Other";
//       const label = meta.construct || code;
  
//       if (!trendByCategory[category]) trendByCategory[category] = {};
  
//       trendByCategory[category][label] = points.map((p) => ({
//         x: new Date(p.x),
//         y: Number(p.y),
//       }));
//     }
  
//     return (
//       <div className="trend-container">
//         {Object.entries(trendByCategory).map(([category, constructs]) => {
//           const datasets = Object.entries(constructs).map(([label, points], i) => ({
//             label,
//             data: points,
//             fill: false,
//             tension: 0.3,
//             borderWidth: 2,
//             pointRadius: 3,
//             borderColor: `hsl(${(i * 60) % 360}, 70%, 50%)`,
//             spanGaps: true,
//           }));
  
//           const chartData = { datasets };
  
//           return (
//             <div key={category} style={{ marginBottom: "3rem" }}>
//               <h3>{category}</h3>
//               <Line
//                 data={chartData}
//                 options={{
//                   responsive: true,
//                   scales: {
//                     x: {
//                       type: "time",
//                       time: {
//                         unit: "day",
//                         tooltipFormat: "MMM d",
//                       },
//                       title: {
//                         display: true,
//                         text: "Date",
//                       },
//                     },
//                     y: {
//                       min: 1,
//                       max: 6,
//                       title: {
//                         display: true,
//                         text: "Average Score",
//                       },
//                       ticks: {
//                         stepSize: 1,
//                         callback: (value) =>
//                           ({
//                             1: "Strongly Disagree",
//                             2: "Disagree",
//                             3: "Slightly Disagree",
//                             4: "Slightly Agree",
//                             5: "Agree",
//                             6: "Strongly Agree",
//                           }[value] || value),
//                       },
//                     },
//                   },
//                   plugins: {
//                     legend: { position: "right" },
//                   },
//                 }}
//               />
//             </div>
//           );
//         })}
//       </div>
//     );
//   };
  
// export default TrendChart;

import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  TimeScale,
  Tooltip,
  Legend,
} from "chart.js";
import "chartjs-adapter-date-fns";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  TimeScale,
  Tooltip,
  Legend
);

const Construct_code_category = [
  { construct: "Self-Efficacy", code: "se", category: "Student Beliefs" },
  { construct: "Cognitive Engagement", code: "cog", category: "Learning Behaviors" },
  { construct: "Behavioral Engagement", code: "beh", category: "Learning Behaviors" },
  { construct: "Affective Engagement", code: "aff", category: "Learning Behaviors" },
  { construct: "Autonomy", code: "aut", category: "Classroom Context" },
  { construct: "Relatedness", code: "rel", category: "Classroom Context" },
  { construct: "Value", code: "val", category: "Student Beliefs" },
  { construct: "Self-Regulation", code: "srt", category: "Learning Behaviors" },
  { construct: "Intrinsic Motivation", code: "amot", category: "Student Beliefs" },
  { construct: "Extrinsic Motivation", code: "cmot", category: "Student Beliefs" },
  { construct: "Academic Burden", code: "bur", category: "Student Beliefs" },
  { construct: "Belongingness", code: "bel", category: "Classroom Context" },
  { construct: "Cultural Congruity", code: "cult", category: "Classroom Context" },
  { construct: "Withdrawal Intention", code: "with", category: "Learning Behaviors" },
];

const KNOWN_CATEGORIES = ["Student Beliefs", "Learning Behaviors", "Classroom Context"];

const TrendChart = ({ trendData }) => {
  const ConstructMeta = {};
  Construct_code_category.forEach(({ code, construct, category }) => {
    ConstructMeta[code] = { construct, category };
  });

  // ========== NEW API SHAPE: Array of rows (quizTitle/groupCode/avgScore) ==========
  if (Array.isArray(trendData)) {
    const sorted = [...trendData].sort((a, b) => (a.quizId ?? 0) - (b.quizId ?? 0));

    // Base labels (x-axis) in order
    const baseLabels = Array.from(
      new Map(
        sorted.map((r) => [
          r.quizTitle || `Quiz ${r.quizId}`,
          r.quizTitle || `Quiz ${r.quizId}`,
        ])
      ).values()
    );

    // category -> construct -> { quizTitle: avgScore }
    const seriesByCategory = Object.fromEntries(
      KNOWN_CATEGORIES.map((c) => [c, {}])
    );

    for (const row of sorted) {
      const meta = ConstructMeta[row.groupCode];
      if (!meta || !KNOWN_CATEGORIES.includes(meta.category)) continue; // skip unknowns

      const label = meta.construct;
      const quizTitle = row.quizTitle || `Quiz ${row.quizId}`;
      const y = Number(row.avgScore);

      if (!seriesByCategory[meta.category][label]) {
        seriesByCategory[meta.category][label] = {};
      }
      seriesByCategory[meta.category][label][quizTitle] =
        Number.isFinite(y) ? y : null;
    }

    return (
      <div className="trend-container">
        {KNOWN_CATEGORIES.map((category) => {
          const constructs = seriesByCategory[category];
          const single = baseLabels.length === 1;

          const labels = single ? ["", baseLabels[0], ""] : baseLabels;

          const datasets = Object.entries(constructs).map(([label, series], i) => {
            const baseData = baseLabels.map((qt) =>
              qt in series ? series[qt] : null
            );
            const data = single ? [null, baseData[0] ?? null, null] : baseData;

            return {
              label,
              data,
              fill: false,
              tension: 0.3,
              borderWidth: 2,
              pointRadius: 3,
              borderColor: `hsl(${(i * 60) % 360}, 70%, 50%)`,
              spanGaps: true,
            };
          });

          const chartData = { labels, datasets };

          return (
            <div key={category} style={{ marginBottom: "3rem" }}>
              <h3>{category}</h3>
              <Line
                data={chartData}
                options={{
                  responsive: true,
                  scales: {
                    x: {
                      type: "category",
                      title: { display: true, text: "Quiz" },
                    },
                    y: {
                      min: 1,
                      max: 6,
                      title: { display: true, text: "Average Score" },
                      ticks: {
                        stepSize: 1,
                        callback: (value) =>
                          ({
                            1: "Strongly Disagree",
                            2: "Disagree",
                            3: "Slightly Disagree",
                            4: "Slightly Agree",
                            5: "Agree",
                            6: "Strongly Agree",
                          }[value] || value),
                      },
                    },
                  },
                  plugins: {
                    legend: { position: "right" },
                    tooltip: {
                      callbacks: {
                        title: (items) =>
                          items?.[0]?.label ? `Quiz: ${items[0].label}` : "",
                      },
                    },
                  },
                }}
              />
            </div>
          );
        })}
      </div>
    );
  }

  // ========== BACKWARD COMPAT: old { code: [{ x, y }, ...] } with time x-axis ==========
  const timeTrendByCategory = Object.fromEntries(
    KNOWN_CATEGORIES.map((c) => [c, {}])
  );

  for (const [code, points] of Object.entries(trendData || {})) {
    const meta = ConstructMeta[code];
    if (!meta || !KNOWN_CATEGORIES.includes(meta.category)) continue;
    const label = meta.construct;
    timeTrendByCategory[meta.category][label] = (points || []).map((p) => ({
      x: new Date(p.x),
      y: Number(p.y),
    }));
  }

  return (
    <div className="trend-container">
      {KNOWN_CATEGORIES.map((category) => {
        let datasets = Object.entries(timeTrendByCategory[category]).map(
          ([label, points], i) => ({
            label,
            data: points,
            fill: false,
            tension: 0.3,
            borderWidth: 2,
            pointRadius: 3,
            borderColor: `hsl(${(i * 60) % 360}, 70%, 50%)`,
            spanGaps: true,
          })
        );

        // Center if all datasets share a single timestamp
        const uniqueTs = new Set(
          datasets.flatMap((ds) => ds.data.map((p) => +p.x))
        );
        if (uniqueTs.size === 1) {
          const t = [...uniqueTs][0];
          const left = new Date(t - 24 * 60 * 60 * 1000);
          const right = new Date(t + 24 * 60 * 60 * 1000);
          datasets = datasets.map((ds) => {
            const mid = ds.data[0] || { x: new Date(t), y: null };
            return {
              ...ds,
              data: [
                { x: left, y: null },
                { x: mid.x instanceof Date ? mid.x : new Date(t), y: mid.y ?? null },
                { x: right, y: null },
              ],
            };
          });
        }

        const chartData = { datasets };

        return (
          <div key={category} style={{ marginBottom: "3rem" }}>
            <h3>{category}</h3>
            <Line
              data={chartData}
              options={{
                responsive: true,
                scales: {
                  x: {
                    type: "time",
                    time: { unit: "day", tooltipFormat: "MMM d" },
                    title: { display: true, text: "Date" },
                  },
                  y: {
                    min: 1,
                    max: 6,
                    title: { display: true, text: "Average Score" },
                    ticks: {
                      stepSize: 1,
                      callback: (value) =>
                        ({
                          1: "Strongly Disagree",
                          2: "Disagree",
                          3: "Slightly Disagree",
                          4: "Slightly Agree",
                          5: "Agree",
                          6: "Strongly Agree",
                        }[value] || value),
                    },
                  },
                },
                plugins: { legend: { position: "right" } },
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default TrendChart;
